import { formatDate } from '@/utils'
export default {
  filters: {
    formatDate
  }
}